export const ActionTypes = {
  FETCH_ALL: 'services/visionProject/fetch_all',
  FETCH_IMAGE_ANNOTATIONS: 'services/visionProject/fetch_image_annotations',
  FETCH_PROJECT_BY_ID: 'services/visionProject/fetch_project_by_id',
  FETCH_ALL_USE_CASES: 'services/visionProject/fetch_all_use_cases',
  FETCH_TRAINING_DATA: 'services/visionProject/fetch_training_data',
  SET_TRAINING_DATA: 'services/visionProject/set_training_data',
  UPDATE_STEP: 'services/visionProject/update_step',
  GET_VISION_PROJECT_VIDEOS: 'services/visionProject/get_vision_project_videos',
  SET_VISION_PROJECT_VIDEOS: 'services/visionProject/set_vision_project_videos',
  SET_ALL: 'services/visionProject/set_all',
  SET_PROJECT_DETAILS: 'services/visionProject/set_project_details',
  SET_ALL_USE_CASES: 'services/visionProject/set_all_use_cases',
  SET_LOADER_STATUS: 'services/visionProject/set_loader_status',
  SET_MODAL_LOADER_STATUS: 'services/visionProject/set_modal_loader_status',
  UPDATE_VISION_PROJECT: 'services/visionProject/update_vision_project',
  ADD_VISION_PROJECT: 'services/visionProject/add_vision_project',
  DELETE_VISION_PROJECT: 'services/visionProject/delete_vision_project',
  DELETE_VISION_PROJECT_PRODUCT: 'services/visionProject/delete_vision_project_product',
  DELETE_VISION_PROJECT_ARTWORK: 'services/visionProject/delete_vision_project_artwork',
  DELETE_VISION_PROJECT_VIDEO: 'services/visionProject/delete_vision_project_video',
  DELETE_VISION_PROJECT_IMAGE: 'services/visionProject/delete_vision_project_image',
  UPDATE_VISION_PROJECT_ARTWORK: 'services/visionProject/update_vision_project_artwork',
  UPLOAD_VISION_PROJECT_IMAGES: 'services/visionProject/upload_vision_project_images',
  UPLOAD_VISION_PROJECT_VIDEO: 'services/visionProject/upload_vision_project_video',
  FETCH_VISION_PROJECT_IMAGES: 'services/visionProject/fetch_vision_project_images',
  SET_VISION_PROJECT_IMAGES: 'services/visionProject/set_vision_project_images',
  SET_IMAGE_TABLE_LOADER_STATUS: 'services/visionProject/set_image_table_loader_status',
  SET_VIDEO_TABLE_LOADER_STATUS: 'services/visionProject/set_video_table_loader_status',
  ADD_ANNOTATIONS_TO_IMAGE: 'services/visionProject/add_annotations_to_image',
  UPDATE_ANNOTATIONS_OF_IMAGE: 'services/visionProject/update_annotations_of_image',
  SAVE_ANNOTATIONS_BULK: 'services/visionProject/save_annotations_bulk',
  DELETE_ANNOTATIONS_OF_IMAGE: 'services/visionProject/delete_annotations_of_image',
  SET_IMAGE_ANNOTATIONS: 'services/visionProject/set_image_annotations',
  START_TRAINING: 'services/visionProject/start_training',
  STOP_TRAINING: 'services/visionProject/stop_training',
  FETCH_TRAINING_PROGRESS: 'services/visionProject/fetch_training_progress',
  SET_TRAINING_PROGRESS: 'services/visionProject/set_training_progress',
  TEST_MODEL: 'services/visionProject/test_model',
  SET_TEST_MODEL_RESULT: 'services/visionProject/set_test_model_result',
  FETCH_TEST_RESULT: 'services/visionProject/fetch_test_result',
  CONFIGURE_PROJECT: 'services/visionProject/configure_project',
  DEPLOY_MODEL: 'services/visionProject/deploy_model',
  FETCH_DEPLOYED_VISION_PROJECTS_BT_PRODUCT_ID: 'services/visionProject/fetch_deployed_vision_projects_by_productId',
  SET_DEPLOYED_VISION_PROJECTS: 'services/visionProject/set_deployed_vision_projects',
  REMOVE_IMAGE_ANNOTATIONS: 'services/visionProject/remove_image_annotation',
  SET_JOB_VISION_EQUIPMENT_CONFIG: 'services/visionProject/set_job_vision_equipment_config',
  SET_EQUIPMENT_PROJECTS: 'services/visionProject/set_equipment_projects',
  SET_DEPLOYMENT_HISTORY_LOADER_STATUS: 'services/visionProject/set_deployment_history_loader_status',
  GET_VISION_PROJECT_DEPLOYMENT_HISTORY: 'services/visionProject/get_vision_project_deployment_history',
  SET_VISION_PROJECT_DEPLOYMENT_HISTORY: 'services/visionProject/set_vision_project_deployment_history',
  CHECK_CAMERA_STATUS: 'services/visionProject/check_camera_status',
  SET_CAMERA_STATUS: 'services/visionProject/set_camera_status',
  SET_CAMERA_STATUS_LOADER: 'services/visionProject/set_camera_status_loader',
  GET_IMAGE_FROM_S3_BUCKET: 'services/visionProject/get_image_from_s3_bucket',
  SET_IMAGE_FROM_S3_BUCKET: 'services/visionProject/set_image_from_s3_bucket',
  IMAGE_CAPTURE_START: 'services/visionProject/image_capture_start',
  DELETE_SINGLE_IMAGE_FROM_S3: 'services/visionProject/delete_single_image_from_s3',
  DELETE_ALL_IMAGES_FROM_S3_BUCKET: 'services/visionProject/delete_all_images_from_s3_bucket',
  UPLOAD_IMAGES_TO_MONGODB: 'services/visionProject/upload_images_to_mongodb',
  SET_UPLOAD_IMAGE_LOADER: 'services/visionProject/set_upload_image_loader',
  SET_DELETE_IMAGE_LOADER: 'services/visionProject/set_delete_image_loader',
  IS_IMAGE_CAPTURE_PROCESSED: 'services/visionProject/is_image_capture_processed',
  SET_IMAGE_CAPTURE_PROCESSED: 'services/visionProject/set_image_capture_processed',
  SET_START_STOP_LOADER: 'services/visionProject/set_start_stop_loader',
  SET_DELETE_ALL_LOADER: 'services/visionProject/set_delete_all_loader',
  UPLOAD_MEDIA: 'services/visionProject/upload_media',
  SET_MEDIA_UPLOAD_RESULT: 'services/visionProject/set_media_upload_result',
  SET_TRAINING_HISTORY_LOADER_STATUS: 'services/visionProject/set_training_history_loader_status',
  GET_VISION_PROJECT_TRAINING_HISTORY: 'services/visionProject/get_vision_project_training_history',
  SET_VISION_PROJECT_TRAINING_HISTORY: 'services/visionProject/set_vision_project_training_history',
  GET_VISION_PROJECT_STATUS: 'services/visionProject/get_vision_project_status',
  SET_VISION_PROJECT_STATUS: 'services/visionProject/set_vision_project_status',
  FETCH_VISION_AI_TOOLS: 'services/visionProject/fetch_vision_ai_tools',
  SET_VISION_AI_TOOLS: 'services/visionProject/set_vision_ai_tools',
  // Global AOIs and Customer AOIs action types
  FETCH_ALL_GLOBAL_AOIS: 'services/visionProject/fetch_all_global_aois',
  SET_ALL_GLOBAL_AOIS: 'services/visionProject/set_all_global_aois',
  FETCH_CUSTOMER_AOIS: 'services/visionProject/fetch_customer_aois',
  SET_CUSTOMER_AOIS: 'services/visionProject/set_customer_aois',
  FETCH_LABELS_LIST: 'services/visionProject/fetch_labels_list',
  SET_LABELS_LIST: 'services/visionProject/set_labels_list',
  SAVE_CUSTOMER_AOI_SELECTION: 'services/visionProject/save_customer_aoi_selection',
  ADD_CUSTOMER_AOI: 'services/visionProject/add_customer_aoi',
  UPDATE_CUSTOMER_AOI: 'services/visionProject/update_customer_aoi',
  DELETE_CUSTOMER_AOI: 'services/visionProject/delete_customer_aoi',
  REMOVE_GLOBAL_AOI_SELECTION: 'services/visionProject/remove_global_aoi_selection',
  SAVE_TEMP_ANNOTATION: 'services/visionProject/save_temp_annotation',
  FETCH_TEMP_ANNOTATIONS: 'services/visionProject/fetch_temp_annotations',
  FETCH_TEMP_ANNOTATION_BY_IMAGE: 'services/visionProject/fetch_temp_annotation_by_image',
  SET_TEMP_ANNOTATIONS: 'services/visionProject/set_temp_annotations',
  // Batch operations
  FETCH_BATCHES: 'services/visionProject/fetch_batches',
  SET_BATCHES: 'services/visionProject/set_batches',
  DELETE_BATCH: 'services/visionProject/delete_batch',
  MARK_BATCH_AS_NULL: 'services/visionProject/mark_batch_as_null',
  MOVE_BATCH_TO_RAW: 'services/visionProject/move_batch_to_raw',
  DOWNLOAD_BATCH: 'services/visionProject/download_batch',
  FETCH_BATCH_IMAGES: 'services/visionProject/fetch_batch_images',
  SET_BATCH_IMAGES: 'services/visionProject/set_batch_images',
};

const configureProject = ({ projectId, jsonContent, callback }) => ({
  projectId,
  jsonContent,
  callback,
  type: ActionTypes.CONFIGURE_PROJECT,
});

const startTraining = ({ projectId, userId, callback }) => ({
  projectId,
  userId,
  callback,
  type: ActionTypes.START_TRAINING,
});
const stopTraining = ({ projectId, callback }) => ({
  projectId,
  callback,
  type: ActionTypes.STOP_TRAINING,
});

const fetchTrainingProgress = ({ projectId }) => ({
  projectId,
  type: ActionTypes.FETCH_TRAINING_PROGRESS,
});

const setTrainingProgress = ({ trainingProgress }) => ({
  trainingProgress,
  type: ActionTypes.SET_TRAINING_PROGRESS,
});

const fetchAll = ({ params }) => ({
  params,
  type: ActionTypes.FETCH_ALL,
});

const fetchProjectById = ({ projectId }) => ({
  projectId,
  type: ActionTypes.FETCH_PROJECT_BY_ID,
});

const fetchAllUseCases = () => ({
  type: ActionTypes.FETCH_ALL_USE_CASES,
});

const fetchTrainingData = ({ projectId }) => ({
  projectId,
  type: ActionTypes.FETCH_TRAINING_DATA,
});

const setTrainingData = ({ trainingData }) => ({
  trainingData,
  type: ActionTypes.SET_TRAINING_DATA,
});

const fetchImageAnnotations = ({ imageId, projectId }) => ({
  imageId,
  projectId,
  type: ActionTypes.FETCH_IMAGE_ANNOTATIONS,
});

const updateStep = ({ stepParams }) => ({
  stepParams,
  type: ActionTypes.UPDATE_STEP,
});

const getVideos = ({ id }) => ({
  id,
  type: ActionTypes.GET_VISION_PROJECT_VIDEOS,
});

const setVideos = ({ allVideos }) => ({
  allVideos,
  type: ActionTypes.SET_VISION_PROJECT_VIDEOS,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const setModalLoader = ({ showModalLoader }) => ({
  showModalLoader,
  type: ActionTypes.SET_MODAL_LOADER_STATUS,
});

const setAll = ({ allVisionProjects }) => ({
  allVisionProjects,
  type: ActionTypes.SET_ALL,
});

const setProjectDetails = ({ projectDetails }) => ({
  projectDetails,
  type: ActionTypes.SET_PROJECT_DETAILS,
});

const setAllUseCases = ({ useCases }) => ({
  useCases,
  type: ActionTypes.SET_ALL_USE_CASES,
});

const updateVisionProject = ({ data, id, callback }) => ({
  data,
  id,
  callback,
  type: ActionTypes.UPDATE_VISION_PROJECT,
});

const addVisionProject = ({ data, callback }) => ({ data, callback, type: ActionTypes.ADD_VISION_PROJECT });

const deleteVisionProject = ({ id, params }) => ({
  id,
  params,
  type: ActionTypes.DELETE_VISION_PROJECT,
});

const updateVisionProjectArtwork = ({ id, data }) => ({
  id,
  data,
  type: ActionTypes.UPDATE_VISION_PROJECT_ARTWORK,
});

const deleteVisionProjectArtwork = ({ id }) => ({
  id,
  type: ActionTypes.DELETE_VISION_PROJECT_ARTWORK,
});

const deleteVisionProjectVideo = ({ id, fileName, callback }) => ({
  id,
  fileName,
  callback,
  type: ActionTypes.DELETE_VISION_PROJECT_VIDEO,
});

const deleteVisionProjectImage = ({ id, fileName, callback, skipNotification }) => ({
  id,
  fileName,
  callback,
  skipNotification,
  type: ActionTypes.DELETE_VISION_PROJECT_IMAGE,
});

const deleteProductFromProject = ({ productId, id }) => ({
  id,
  productId,
  type: ActionTypes.DELETE_VISION_PROJECT_PRODUCT,
});

const uploadImages = ({ id, data, callback }) => ({
  id,
  data,
  callback,
  type: ActionTypes.UPLOAD_VISION_PROJECT_IMAGES,
});

const uploadVideo = ({ id, data, callback }) => ({
  id,
  data,
  callback,
  type: ActionTypes.UPLOAD_VISION_PROJECT_VIDEO,
});

const uploadMedia = ({ id, data, callback }) => ({
  id,
  data,
  callback,
  type: ActionTypes.UPLOAD_MEDIA,
});

const fetchImages = ({ id, imageParams }) => ({
  id,
  imageParams,
  type: ActionTypes.FETCH_VISION_PROJECT_IMAGES,
});

const setImages = ({ allImages }) => ({
  allImages,
  type: ActionTypes.SET_VISION_PROJECT_IMAGES,
});

const setTableLoader = ({ showTableLoader }) => ({
  showTableLoader,
  type: ActionTypes.SET_IMAGE_TABLE_LOADER_STATUS,
});

const setVideoTableLoader = ({ showVideoTableLoader }) => ({
  showVideoTableLoader,
  type: ActionTypes.SET_VIDEO_TABLE_LOADER_STATUS,
});
const addAnnotationsToImage = ({ data }) => ({
  data,
  type: ActionTypes.ADD_ANNOTATIONS_TO_IMAGE,
});
const updateAnnotationsOfImage = ({ data }) => ({
  data,
  type: ActionTypes.UPDATE_ANNOTATIONS_OF_IMAGE,
});
const saveAnnotationsBulk = ({ projectId, items, callback }) => ({
  projectId,
  items,
  callback,
  type: ActionTypes.SAVE_ANNOTATIONS_BULK,
});
const deleteAnnotationsOfImage = ({ annotationData }) => ({
  annotationData,
  type: ActionTypes.DELETE_ANNOTATIONS_OF_IMAGE,
});
const setImageAnnotations = ({ imageAnnotations }) => ({
  imageAnnotations,
  type: ActionTypes.SET_IMAGE_ANNOTATIONS,
});
const testModel = ({ projectId, image, callback }) => ({
  projectId,
  image,
  callback,
  type: ActionTypes.TEST_MODEL,
});
const setTestModelResult = ({ testModelResult }) => ({
  testModelResult,
  type: ActionTypes.SET_TEST_MODEL_RESULT,
});

const setMediaUploadResult = ({ mediaUploadResult }) => ({
  mediaUploadResult,
  type: ActionTypes.SET_MEDIA_UPLOAD_RESULT,
});

const fetchTestResult = ({ projectId }) => ({
  type: ActionTypes.FETCH_TEST_RESULT,
  projectId,
});
const deployModel = ({ projectId, callback }) => ({
  projectId,
  callback,
  type: ActionTypes.DEPLOY_MODEL,
});

const fetchDeployedVisionProjectsByProductId = ({ productId }) => ({
  productId,
  type: ActionTypes.FETCH_DEPLOYED_VISION_PROJECTS_BT_PRODUCT_ID,
});

const setDeployedVisionProjects = ({ deployedVisionProjects }) => ({
  deployedVisionProjects,
  type: ActionTypes.SET_DEPLOYED_VISION_PROJECTS,
});

const removeAnnotations = ({ projectId, annotationId }) => ({
  projectId,
  annotationId,
  type: ActionTypes.REMOVE_IMAGE_ANNOTATIONS,
});

const setJobVisionEquipmentConfig = ({ missedList }) => ({
  missedList,
  type: ActionTypes.SET_JOB_VISION_EQUIPMENT_CONFIG,
});

const setEquipmentProjects = ({ equipmentProjects }) => ({
  equipmentProjects,
  type: ActionTypes.SET_EQUIPMENT_PROJECTS,
});

const setDeploymentHistoryLoader = ({ showDeploymentHistoryLoader }) => ({
  showDeploymentHistoryLoader,
  type: ActionTypes.SET_DEPLOYMENT_HISTORY_LOADER_STATUS,
});

const getDeploymentHistory = ({ id }) => ({
  id,
  type: ActionTypes.GET_VISION_PROJECT_DEPLOYMENT_HISTORY,
});

const setDeploymentHistory = ({ allDeploymentHistory }) => ({
  allDeploymentHistory,
  type: ActionTypes.SET_VISION_PROJECT_DEPLOYMENT_HISTORY,
});

const checkCameraStatus = ({ deviceId }) => ({
  deviceId,
  type: ActionTypes.CHECK_CAMERA_STATUS,
});

const setCameraStatus = ({ cameraStatus }) => ({
  cameraStatus,
  type: ActionTypes.SET_CAMERA_STATUS,
});

const setCameraStatusLoader = ({ showCameraStatusLoader }) => ({
  showCameraStatusLoader,
  type: ActionTypes.SET_CAMERA_STATUS_LOADER,
});

const getImageFromS3Bucket = ({ projectId }) => ({
  projectId,
  type: ActionTypes.GET_IMAGE_FROM_S3_BUCKET,
});

const setImageFromS3Bucket = ({ imageData }) => ({
  imageData,
  type: ActionTypes.SET_IMAGE_FROM_S3_BUCKET,
});

const setDeleteImageLoader = ({ showDeleteImageLoader }) => ({
  showDeleteImageLoader,
  type: ActionTypes.SET_DELETE_IMAGE_LOADER,
});

const imageCaptureStartStop = ({ deviceId, action, callback }) => ({
  deviceId,
  action,
  callback,
  type: ActionTypes.IMAGE_CAPTURE_START,
});

const deleteSingleImageFromS3 = ({ imageKey, projectId }) => ({
  imageKey,
  projectId,
  type: ActionTypes.DELETE_SINGLE_IMAGE_FROM_S3,
});

const deleteAllImagesFromS3Bucket = ({ projectId }) => ({
  projectId,
  type: ActionTypes.DELETE_ALL_IMAGES_FROM_S3_BUCKET,
});
const uploadImagesToMongoDb = ({ images, projectId, batchId, uploadedBy, callback }) => ({
  images,
  projectId,
  batchId,
  uploadedBy,
  callback,
  type: ActionTypes.UPLOAD_IMAGES_TO_MONGODB,
});
const setUploadImageLoader = ({ showUploadImageLoader }) => ({
  showUploadImageLoader,
  type: ActionTypes.SET_UPLOAD_IMAGE_LOADER,
});

const isImageCaptureProcessed = ({ projectId, deviceId }) => ({
  projectId,
  deviceId,
  type: ActionTypes.IS_IMAGE_CAPTURE_PROCESSED,
});

const setImageCaptureProcessed = ({ isProcessed }) => ({
  isProcessed,
  type: ActionTypes.SET_IMAGE_CAPTURE_PROCESSED,
});

const setStartStopLoader = ({ showStartStopLoader }) => ({
  showStartStopLoader,
  type: ActionTypes.SET_START_STOP_LOADER,
});

const setDeleteAllLoader = ({ showDeleteAllLoader }) => ({
  showDeleteAllLoader,
  type: ActionTypes.SET_DELETE_ALL_LOADER,
});

const setTrainingHistoryLoader = ({ showTrainingHistoryLoader }) => ({
  showTrainingHistoryLoader,
  type: ActionTypes.SET_TRAINING_HISTORY_LOADER_STATUS,
});

const getTrainingHistory = ({ id }) => ({
  id,
  type: ActionTypes.GET_VISION_PROJECT_TRAINING_HISTORY,
});

const setTrainingHistory = ({ allTrainingHistory }) => ({
  allTrainingHistory,
  type: ActionTypes.SET_VISION_PROJECT_TRAINING_HISTORY,
});
const getVisionProjectStatus = ({ productId, callback }) => ({
  productId,
  callback,
  type: ActionTypes.GET_VISION_PROJECT_STATUS,
});
const setVisionProjectStatus = ({ status }) => ({
  status,
  type: ActionTypes.SET_VISION_PROJECT_STATUS,
});

const fetchVisionAiTools = () => ({
  type: ActionTypes.FETCH_VISION_AI_TOOLS,
});

const setVisionAiTools = ({ visionProjectAiTools }) => ({
  visionProjectAiTools,
  type: ActionTypes.SET_VISION_AI_TOOLS,
});

// Global AOIs and Customer AOIs actions
const fetchAllGlobalAois = () => ({
  type: ActionTypes.FETCH_ALL_GLOBAL_AOIS,
});

const setAllGlobalAois = ({ allGlobalAois }) => ({
  allGlobalAois,
  type: ActionTypes.SET_ALL_GLOBAL_AOIS,
});

const fetchCustomerAois = () => ({
  type: ActionTypes.FETCH_CUSTOMER_AOIS,
});

const setCustomerAois = ({ customerAois }) => ({
  customerAois,
  type: ActionTypes.SET_CUSTOMER_AOIS,
});

const fetchLabelsList = () => ({
  type: ActionTypes.FETCH_LABELS_LIST,
});

const setLabelsList = ({ labelsList }) => ({
  labelsList,
  type: ActionTypes.SET_LABELS_LIST,
});

const saveCustomerAoiSelection = ({ globalAois, projectId, callback }) => ({
  globalAois,
  projectId,
  callback,
  type: ActionTypes.SAVE_CUSTOMER_AOI_SELECTION,
});

const addCustomerAoi = ({ aoiData, projectId, callback }) => ({
  aoiData,
  projectId,
  callback,
  type: ActionTypes.ADD_CUSTOMER_AOI,
});

const updateCustomerAoi = ({ aoiData, projectId, callback }) => ({
  aoiData,
  projectId,
  callback,
  type: ActionTypes.UPDATE_CUSTOMER_AOI,
});

const deleteCustomerAoi = ({ aoiIndex, projectId, callback, errorCallback }) => ({
  aoiIndex,
  projectId,
  callback,
  errorCallback,
  type: ActionTypes.DELETE_CUSTOMER_AOI,
});

const removeGlobalAoiSelection = ({ aoiIndex, projectId, callback, errorCallback }) => ({
  aoiIndex,
  projectId,
  callback,
  errorCallback,
  type: ActionTypes.REMOVE_GLOBAL_AOI_SELECTION,
});

const saveTempAnnotation = ({ projectId, imageId, annotations, callback }) => ({
  projectId,
  imageId,
  annotations,
  callback,
  type: ActionTypes.SAVE_TEMP_ANNOTATION,
});

const fetchTempAnnotations = ({ projectId, callback }) => ({
  projectId,
  callback,
  type: ActionTypes.FETCH_TEMP_ANNOTATIONS,
});

const setTempAnnotations = ({ tempAnnotations }) => ({
  tempAnnotations,
  type: ActionTypes.SET_TEMP_ANNOTATIONS,
});

const fetchTempAnnotationByImage = ({ projectId, imageId, callback }) => ({
  projectId,
  imageId,
  callback,
  type: ActionTypes.FETCH_TEMP_ANNOTATION_BY_IMAGE,
});

// Batch operations
const fetchBatches = ({ projectId }) => ({
  projectId,
  type: ActionTypes.FETCH_BATCHES,
});

const setBatches = ({ batches }) => ({
  batches,
  type: ActionTypes.SET_BATCHES,
});

const deleteBatch = ({ projectId, batchId, statusFilter, callback }) => ({
  projectId,
  batchId,
  statusFilter,
  callback,
  type: ActionTypes.DELETE_BATCH,
});

const markBatchAsNull = ({ projectId, batchId, statusFilter, callback }) => ({
  projectId,
  batchId,
  statusFilter,
  callback,
  type: ActionTypes.MARK_BATCH_AS_NULL,
});

const moveBatchToRaw = ({ projectId, batchId, statusFilter, callback }) => ({
  projectId,
  batchId,
  statusFilter,
  callback,
  type: ActionTypes.MOVE_BATCH_TO_RAW,
});

const downloadBatch = ({ projectId, batchId, statusFilter }) => ({
  projectId,
  batchId,
  statusFilter,
  type: ActionTypes.DOWNLOAD_BATCH,
});

const fetchBatchImages = ({ projectId, batchId }) => ({
  projectId,
  batchId,
  type: ActionTypes.FETCH_BATCH_IMAGES,
});

const setBatchImages = ({ batchImages }) => ({
  batchImages,
  type: ActionTypes.SET_BATCH_IMAGES,
});

export default {
  configureProject,
  startTraining,
  fetchAll,
  setLoader,
  setAll,
  setAllUseCases,
  fetchAllUseCases,
  fetchTrainingData,
  setTrainingData,
  fetchTrainingProgress,
  setTrainingProgress,
  getVideos,
  setVideos,
  updateStep,
  setModalLoader,
  fetchProjectById,
  setProjectDetails,
  updateVisionProject,
  addVisionProject,
  deleteVisionProject,
  deleteVisionProjectArtwork,
  deleteProductFromProject,
  updateVisionProjectArtwork,
  deleteVisionProjectVideo,
  deleteVisionProjectImage,
  uploadImages,
  uploadVideo,
  uploadMedia,
  fetchImages,
  setImages,
  setTableLoader,
  setVideoTableLoader,
  fetchImageAnnotations,
  addAnnotationsToImage,
  updateAnnotationsOfImage,
  saveAnnotationsBulk,
  deleteAnnotationsOfImage,
  setImageAnnotations,
  testModel,
  setTestModelResult,
  setMediaUploadResult,
  fetchTestResult,
  deployModel,
  fetchDeployedVisionProjectsByProductId,
  setDeployedVisionProjects,
  removeAnnotations,
  setJobVisionEquipmentConfig,
  setEquipmentProjects,
  setDeploymentHistoryLoader,
  getDeploymentHistory,
  setDeploymentHistory,
  checkCameraStatus,
  setCameraStatus,
  setCameraStatusLoader,
  getImageFromS3Bucket,
  setImageFromS3Bucket,
  imageCaptureStartStop,
  deleteSingleImageFromS3,
  setDeleteImageLoader,
  deleteAllImagesFromS3Bucket,
  uploadImagesToMongoDb,
  setUploadImageLoader,
  isImageCaptureProcessed,
  setImageCaptureProcessed,
  setStartStopLoader,
  setDeleteAllLoader,
  setTrainingHistoryLoader,
  getTrainingHistory,
  setTrainingHistory,
  stopTraining,
  getVisionProjectStatus,
  setVisionProjectStatus,
  fetchVisionAiTools,
  setVisionAiTools,
  // Global AOIs and Customer AOIs exports
  fetchAllGlobalAois,
  setAllGlobalAois,
  fetchCustomerAois,
  setCustomerAois,
  fetchLabelsList,
  setLabelsList,
  saveCustomerAoiSelection,
  addCustomerAoi,
  updateCustomerAoi,
  deleteCustomerAoi,
  removeGlobalAoiSelection,
  saveTempAnnotation,
  fetchTempAnnotations,
  fetchTempAnnotationByImage,
  setTempAnnotations,
  // Batch operations
  fetchBatches,
  setBatches,
  deleteBatch,
  markBatchAsNull,
  moveBatchToRaw,
  downloadBatch,
  fetchBatchImages,
  setBatchImages,
};
